import { computed, InjectionKey } from 'vue';
import { RepositoryFactory, Repositories } from '@/repositories/RepositoryFactory';

const PointRepository = RepositoryFactory.get('point') as Repositories['point'];

const POINT_ENABLED = //true; // DEBUG
  `${
    process.env.NODE_ENV === 'local' ? window.POINT_ENABLED || process.env.VUE_APP_POINT_ENABLED : window.POINT_ENABLED
  }` === 'true';

export const usePoint = () => {
  /**
   * 有効/無効
   */
  const enabled = computed(() => POINT_ENABLED);

  /**
   * ポイント情報
   */
  const get = async () => {
    return await PointRepository.get();
  };

  /**
   * ポイント履歴一覧
   */
  const getTransfer = async (from = 0, limit = 50) => {
    return await PointRepository.getTransfer(from, limit);
  };

  /**
   * ポイント履歴詳細
   * @param transferId
   */
  const getTransferDetail = async (transferId: string) => {
    return await PointRepository.getTransferDetail(transferId);
  };

  /**
   * ポイントアクションを実行
   * @param actionId
   * @param token
   * @param shopChId
   * @param lat CS-8234
   * @param lng CS-8234
   */
  const action = async (
    actionId: string,
    token: string | null = null,
    shopChId: string | null = null,
    lat: number | null = null,
    lng: number | null = null
  ) => {
    return await PointRepository.action(actionId, token, shopChId, lat, lng);
  };

  return {
    enabled,
    get,
    getTransfer,
    getTransferDetail,
    action,
  };
};

type PointType = ReturnType<typeof usePoint>;
export const PointKey: InjectionKey<PointType> = Symbol('Point');
